import axios, { getRequestHeaders } from "./axios";

export const fetchDashboardsAPI = async ({
  activeBrand,
  setIsLoading = () => {},
}) => {
  try {
    setIsLoading(true);
    const response = await axios.get(
      `/dashboard/get-dashboard-list/${activeBrand}/`,
      {
        headers: getRequestHeaders(),
      }
    );
    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const createDashboardAPI = async ({
  setIsLoading,
  activeBrand,
  label,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.post(
      `/dashboard/${activeBrand}/`,
      {
        label,
      },
      {
        headers: getRequestHeaders(),
      }
    );
    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const fetchSectionsAPI = async ({
  setError = () => {},
  dashboardId,
  setIsLoading,
  setData,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.get(`/dashboard/${dashboardId}/sections/`, {
      headers: getRequestHeaders(),
    });

    setIsLoading(false);
    setData(response?.data);
    setError("")
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error?.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setError(msg);
    setIsLoading(false);
    setError(msg);
  }
};

export const createDashboardSectionAPI = async ({
  dashboardId,
  setIsLoading,
  label,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.post(
      `/dashboard/${dashboardId}/sections/`,
      {
        label,
      },
      {
        headers: getRequestHeaders(),
      }
    );

    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const addWidgetToSectionAPI = async ({
  dashboardId,
  sectionId,
  setIsLoading = () => {},
  msgId,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.post(
      `/dashboard/${dashboardId}/sections/${sectionId}/widgets/add-widget/`,
      {
        message_id: msgId,
      },
      {
        headers: getRequestHeaders(),
      }
    );

    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const fetchDashboardAPI = async ({
  setIsLoading,
  dashboardId,
  setError,
  setData,
}) => {

  try {
    setIsLoading(true);
    const response = await axios.get(`/dashboard/${dashboardId}/`, {
      headers: getRequestHeaders(),
    });

    setIsLoading(false);
    setData(response?.data);
    setError("");
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error?.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setError(msg);
    setIsLoading(false);
    return false;
  }
};

export const updateDashboardLabelAPI = async ({
  dashboardId,
  label,
  setIsLoading,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.put(
      `dashboard/${dashboardId}/update-dashboard-label/`,
      {
        label,
      },
      {
        headers: getRequestHeaders(),
      }
    );

    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const deleteDashboardAPI = async ({ dashboardId, setIsLoading }) => {
  try {
    setIsLoading(true);
    const response = await axios.delete(`dashboard/${dashboardId}/`, {
      headers: getRequestHeaders(),
    });

    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const deleteDashboardSectionAPI = async ({
  dashboardId,
  sectionId,
  setIsLoading,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.delete(
      `/dashboard/${dashboardId}/sections/${sectionId}/`,
      {
        headers: getRequestHeaders(),
      }
    );

    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const updateSectionLabelAPI = async ({
  setIsLoading,
  dashboardId,
  sectionId,
  label,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.patch(
      `/dashboard/${dashboardId}/sections/${sectionId}/`,
      {
        label,
      },
      {
        headers: getRequestHeaders(),
      }
    );

    setIsLoading(false);
    return response?.data;
  } catch (e) {
    console.log("Je;");
    const msg = e?.response?.error?.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const updateSectionWidgetLabelAPI = async ({
  setIsLoading,
  dashboardId,
  sectionId,
  widgetId,
  label,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.patch(
      `/dashboard/${dashboardId}/sections/${sectionId}/widgets/update-widget-label/${widgetId}/`,
      {
        label,
      },
      {
        headers: getRequestHeaders(),
      }
    );

    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const deleteSectionWidgetAPI = async ({
  dashboardId,
  sectionId,
  widgetId,
  setIsLoading,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.delete(
      `dashboard/${dashboardId}/sections/${sectionId}/widgets/${widgetId}/`,
      {
        headers: getRequestHeaders(),
      }
    );

    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};

export const executeWidgetSqlAPI = async ({
  setIsLoading,
  dashboardId,
  sectionId,
  widgetId,
}) => {
  try {
    setIsLoading(true);
    const response = await axios.get(
      `dashboard/${dashboardId}/sections/${sectionId}/widgets/execute-sql/${widgetId}/`,
      {
        headers: getRequestHeaders(),
      }
    );

    setIsLoading(false);
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);
    setIsLoading(false);
    return false;
  }
};
